import React from 'react';
import { Line } from 'react-chartjs-2';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Tooltip,
    Legend,
} from 'chart.js';
import zoomPlugin from 'chartjs-plugin-zoom';

ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Tooltip,
    Legend,
    zoomPlugin
);

const Linea = ({ datos }) => {
    // Aquí se corrige para que busque la propiedad `datasets` en lugar de `data`.
    const datasets = Array.isArray(datos.datasets) ? datos.datasets : [{
        label: datos.titulo,
        data: datos.data,
        borderColor: datos.colors?.[0] || 'rgba(75,192,192,1)',
        backgroundColor: datos.colors?.[0] || 'rgba(75,192,192,0.2)',
        fill: false,
        tension: 0.3,
        pointRadius: 1,
        pointHoverRadius: 1,
    }];

    const data = {
        labels: datos.labels,
        // Y aquí se pasa la propiedad `datasets` que ya contiene los datos del gráfico.
        datasets: datasets,
    };

    const options = {
        responsive: true,
        plugins: {
            legend: {
                display: true,
                position: 'top',
            },
            title: {
                display: true,
                text: datos.titulo,
                font: {
                    size: 18,
                    weight: 'bold',
                },
            },
            zoom: {
                pan: {
                    enabled: true,
                    mode: 'x',
                },
                zoom: {
                    wheel: {
                        enabled: true,
                    },
                    pinch: {
                        enabled: true
                    },
                    mode: 'x',
                }
            }
        },
        scales: {
            y: {
                beginAtZero: true,
                ticks: {
                    display: true,
                    precision: 0,
                },
                grid: {
                    display: true,
                },
            },
            x: {
                ticks: {
                    autoSkip: true,
                    maxTicksLimit: 15,
                },
                grid: {
                    display: true,
                },
            },
        },
    };

    return <Line data={data} options={options} />;
};

export default Linea;